export const enum SmartButtonActionType {
    Reply = 'reply',
    Url = 'url',
}
